import React from 'react';
import Logo from '../Logo/Logo'
import Navigations from '../Navigations/Navigations';
import MyHeader from "./Header.module.css";
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { ShareModal } from '../ShareModal/ShareModal';
import { UserAvatar } from '../Avatar/UserAvatar';
import DocumentMembers from '../Members/members';
import Modes from './modes';
import CompleteDocument from '../CompleteDoc/completeDoc';
import publicIcon from '../../assets/world.svg';
import privateIcon from '../../assets/lock.svg';
import SavingStatus from '../SavingStatus/savingStatus ';
import { Tooltip } from 'antd';
import TemplateActiveToggle from '../TemplateActiveToggle';
import TemplateThumbnail from '../TemplateThumbnail';
import DocumentTitle from '../DocumentTitle/DocumentTitle';
import HeaderAvatar from '../Avatar/HeaderAvatar';
import AppLauncherModal from '../AppLauncher/AppLauncherModal';
import OfflineToggle from '../OfflineToggle';


const Header = ({ fileDisplay }) => {
    const { documentInfo, isReadOnly, userInfo, savingData, isTemplateDocument } = useDocument();
    return (

        <div id='myy-header' className={MyHeader.headerMain}>
            <Logo />
            <div className={MyHeader.headerCol} style={{ justifyContent: isReadOnly ? 'center' : 'flex-end' }}>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'baseline', marginBottom: '-8px' }}>
                    <DocumentTitle alreadyAligned={fileDisplay} documentInfo={documentInfo} />
                    {!isTemplateDocument && <div>
                        {documentInfo?.privacyId == 2 ? (
                            <Tooltip title='Private documnet'>
                                <img src={privateIcon} alt='Private documnet' style={{ width: '12px' }} />
                            </Tooltip>
                        )
                            : (
                                <Tooltip title='Public documnet' >
                                    <img src={publicIcon} alt='Public documnet' style={{ width: '15px' }} />
                                </Tooltip>
                            )}
                    </div>}
                    {
                        !isReadOnly && !isTemplateDocument && <CompleteDocument />
                    }
                    <SavingStatus />
                </div>
                {fileDisplay && <Navigations />}
            </div>
            <div style={{ marginRight: '8px' }}>
                {!isTemplateDocument && <DocumentMembers />}
            </div>
            {/* Sits outside titleBarButtons, whose width is fixed by the buttons it holds. */}
            {!isTemplateDocument && !isReadOnly && (
                <div style={{ marginRight: '8px' }}>
                    <OfflineToggle scale={0.8} />
                </div>
            )}
            {/* minWidth, not width: this reserves space so the header doesn't
                jump as Share appears, but still grows for its contents. Fixed
                at 140px the buttons overflowed the left edge (justify-content
                is flex-end) and collided with the offline switch. */}
            <div className={MyHeader.titleBarButtons} style={{ minWidth: documentInfo?.createBy == userInfo.userId ? '140px' : '92px' }}>
                {documentInfo?.createBy == userInfo.userId && !isTemplateDocument && (
                    <>
                        <ShareModal />

                    </>
                )}
                <AppLauncherModal scale={0.8}/>
                {documentInfo &&
                    <Modes />}
                {isTemplateDocument && <TemplateActiveToggle />}
                {isTemplateDocument && <TemplateThumbnail />}
                <HeaderAvatar scale={0.8} />
            </div>
        </div>
    )
};
export default Header;

